// extracted by mini-css-extract-plugin
export default {"productDescription":"Kba-z","featuredDescription":"Lba-z","description":"Mba-z","more":"Nba-z","descriptionSku":"Oba-z"};